import * as React from 'react';

type Props = {
  message: string;
  icon?: '!' | '?';
};

export const InfoIcon = ({ message, icon = '!' }: Props) => {
  return (
    <i
      className={
        'fa-light info-icon' +
        (icon === '!' ? ' fa-circle-info' : ' fa-question-circle')
      }
      title={message}
    ></i>
  );
};
